export enum TicketSource {
    B8AK = 1,
    EXTERNAL = 2,
    PWA = 3,
  }